"use client"
import React from "react"
import Navbar from "../../components/agent/common/Navbar"
import CampaignsList from "../../components/agent/marketing/CampaignsList"

const AgentMarketingCampaigns = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <CampaignsList />
      </main>
    </div>
  )
}

export default AgentMarketingCampaigns